module.exports = __webpack_public_path__ + "static/media/SDFSA_5-384w.7027ee71.webp";